import { distance } from 'fastest-levenshtein';
import { BasicExpert } from "../types";


// Filter out experts that have a higher difference than this.
const max_difference = 4;

// The max length of the list. (Can only be reached if there are this many substrings.)
const max_length = 10;

// The length of the list unless there is a higher count of substrings.
const preferred_length = 5;

export interface FilteredExpert {
    uuid: string,
    Nimi: string,
    difference: number
}


const expertsToBasic = (experts: FilteredExpert[]): BasicExpert[] =>
    experts.map(expert => ({
        uuid: expert.uuid,
        Nimi: expert.Nimi
    }));


export const filterAndSortExperts = (
    experts: BasicExpert[] | null,
    searchStr: string
): BasicExpert[] => {
    try {
        if (!experts) return [];

        searchStr = searchStr.toLowerCase();

        const startsWith: BasicExpert[] = [];
        let substringOf: BasicExpert[] = [];
        let included: FilteredExpert[] = [];

        experts.forEach(expert => {
            const name: string = expert.Nimi.toLowerCase();

            if (name.startsWith(searchStr)) {
                startsWith.push(expert);
                return;
            }

            if (name.includes(searchStr)) {
                substringOf.push(expert);
                return;
           }

            // 1. Calculate levenshtein distance.
            // 2. Reduce the difference between the sizes of the search string and the name.
            const d = distance(searchStr, name) - name.length + searchStr.length;

            if (d <= max_difference) included.push({
                ...expert,
                difference: d
            });
        });

        substringOf = startsWith.concat(substringOf);

        if (substringOf.length > 3)
            return startsWith.concat(substringOf).slice(0, max_length);

        included.sort((a, b) => a.difference - b.difference);

        if  (substringOf.length > 0 ) {
            if ( searchStr.length > 7 ||
                 searchStr.includes(' '))  return substringOf;

            const close_enough = included.filter(expert => expert.difference <= 1);

            return substringOf.concat(
                expertsToBasic(close_enough)
            ).slice(0, preferred_length);
        }

        if (included.length === 0) return [];

        const best_diff = included[0].difference;

        included = included.filter(expert => expert.difference <= best_diff + 1);

        return substringOf.concat(
            expertsToBasic(included)
        ).slice(0, preferred_length);

    } catch (error) {
        console.log(error);
        return [];
    }
};
